<template>
    <transition name="slide">
        <div class="pop-box" v-if="config" v-show="config.show" @click.self="hideBook">
            <div class="pop-box-inner">
                <div class="title">活动期间可享受全年抄底价</div>
                <div class="fuli-title">您可以享受</div>
                <ul class="fuli-list">    
                    <li class="fuli-item" v-for="(item, index) of fuliList" :key="index">
                        <div class="name" v-text="item.name"></div>
                        <div class="val" v-text="item.val"></div>
                    </li>
                </ul>

                <div class="text">填写联系方式完成预约</div>
                <!--电话号码-->
                <div class="phone-wrap"><input class="input-phone" v-model="info.mobile" maxlength="11" placeholder="请输入手机号码"/></div>
                <!--验证码-->
                <div class="veri-code-box" v-show="showVeriCode">
                    <span class="code"><input maxlength="6" v-model="info.veriCode" placeholder="请输入短信验证码"></span>
                    <span class="get-code-btn" :class="[getCodeBtnCls]" @click.stop="getVericode">{{veriBtnTxt}}</span>
                </div>
                <!--提交-->
                <div class="book-btn" :class="{'is-mt': isMt}" @click.stop="submitBook">预约享优惠</div>
            </div>
        </div>
    </transition>
</template>

<script>
import qs from 'querystring';
import toast from '@gfe/app-common-toast';

import {urlHost, searchObj} from '../tools/gethost.js';
import toLogin from '../tools/login.js';

export default {
    name: 'book-shop-component',
    data () {
        return {
            info: {
                mobile: '',
                veriCode: ''
            },
            showVeriCode: false,
            veriBtnTxt: '发送验证码',
            getCodeBtnCls: '',

            isMt: /meituan/.test(urlHost)
        };
    },
    props: ['config'],
    methods: {
        hideBook() {
            this.config.show = false;
            this.showVeriCode = false;
            this.info.veriCode = '';
        },
        checkLogin(cb) {
            if (this.config.isLogin) {
                cb();
            } else {
                toLogin()
            }
        },
        /**
         * 校验电话号码
         */
        checkMobile(mobileNum) {
            let flag = /1\d{10}/.test(mobileNum);

            !flag && toast('请输入正确的手机号码');

            return flag;
        },

        /**
         * 预约提交
        */
        submitBook(){
            this.checkLogin(() => {
                let self = this;
                let { mobile, veriCode } = this.info;
                let { shopId=0, productId=0 } = this.config.shopInfo || {};

                // 校验电话
                if (!this.checkMobile(mobile)) return;
    
                // 校验验证码
                if (this.showVeriCode && veriCode.length === 0) {
                    toast('请输入验证码');
                    return;
                }
                
                //data
                let data = {
                    shopId,
                    productId,
                    mobile,
                    verifyCode: veriCode
                }
                
                // send
                let { fetchJsonp, getReqApi } = this;
                let { booking } = getReqApi();
                fetchJsonp(`${booking}?${qs.stringify(data)}`, data => {
                    let {code, msg} = data;
    
                    /* code:200:请求成功
                        501:参数错误
                        502:已预约过该商户
                        601:需要验证码
                        602:验证码错误
                        603:未登录 */
                    switch (code) {
                        case 200:   this.config.shopInfo.booked = true;
                                    this.hideBook(); 
                                    toast('预约成功');
                                    break;
                        case 500: toast(msg);                        break;
                        case 501: toast('参数错误');                  break;
                        case 502: toast('已预约过该商户');            break;
                        case 601: this.showVeriCode = true;          break;
                        case 602: toast('验证码错误');                break;
                    }
                });
            });
        },

        /**
         * 倒计时
         */
        countDown(sec=60){
            let time = sec;

            this.tId = setInterval(()=>{
                time--;

                if ( time <= 0 ) {
                    clearInterval(this.tId);

                    this.veriBtnTxt = '发送验证码';
                    this.getCodeBtnCls = '';
                } else {
                    this.veriBtnTxt = `重新发送(${time})`;
                    this.getCodeBtnCls = 'gray';
                }
            }, 1000);
        },

        /**
         * 获取验证码
         */
        getVericode(){
            this.checkLogin(() => {
                let { mobile } = this.info;
    
                // 校验电话
                if (!this.checkMobile(mobile)) return;
    
                // 判断是否在倒计时
                if (/\d/.test(this.veriBtnTxt)) return;

                // 倒计时
                this.countDown();
    
                // data
                let data = {
                    mobile
                };

                // 发送请求
                let { fetchJsonp, getReqApi } = this;
                let { phoneverifycode } = getReqApi();
                fetchJsonp(`${phoneverifycode}?${qs.stringify(data)}`, data => {
                    let { code } = data;
    
                    switch(code) {
                        case 200: toast('验证码发送成功，请注意查收'); break;
                        case 501: toast('手机号格式错误');            break;
                        case 502: toast('网络繁忙');                 break;
                    }
                });
            });
        }
    },
    computed: {
        fuliList() {
            // toShopPresent: '到店礼',
            // orderPresent : '预约礼',
            let { toShopPresent, orderPresent } = this.config.shopInfo || {};
            let arr = [];

            if ( toShopPresent && orderPresent ) {
                arr = [{
                    name: '到店礼',
                    val: toShopPresent
                },
                {
                    name: '订单礼',
                    val: orderPresent
                }];
            }

            return [
                {
                    name: '嗨购礼',
                    val: '到店扫码支付享随机免单、100%立减&中奖'
                },
                ...arr
            ]
        }
    },
    components: {
    }
}
</script>

<style lang="less" scoped>
    .border-1px(@clr: #fff) {
        position: absolute;
        top: 0;
        left: 0;
        width: 200%;
        height: 200%;
        z-index: 0;
        content: "";
        border: 1px solid @clr;
        -webkit-transform: scale(0.5);
        -webkit-transform-origin: 0 0;
        transform: scale(0.5);
        transform-origin: 0 0;
        -webkit-box-sizing: border-box; // Safari <= 5
        -moz-box-sizing: border-box; // Firefox <= 19
        box-sizing: border-box;
    }
    input {
        outline: none;
        border: none;
        background: transparent;
    }
    .pop-box {
        position: fixed;
        left: 0;
        top: 0;
        z-index: 11;
        width: 100%;
        height: 100%;
        background: rgba(0,0,0,.5);
    }
    .pop-box-inner {
        position: absolute;
        left: 0;
        bottom: 0;
        width: 100%;
        padding: 2.1rem 1.5rem 2rem;
        box-sizing: border-box;
        text-align: left;
        background: #fff;
        font-family: PingFangSC-Regular;

        .title {
            font-family: PingFangSC-Medium;
            font-size: 1.8rem;
            color: #333333;
            text-align: center;
            line-height: 2.5rem;
        }
        .fuli-title {
            font-size: 1.4rem;
            line-height: 2rem; 
            color: #333333;
            margin-top: 1.7rem;
        }
        .fuli-list {
            margin-top: 0.8rem;
        }
        .fuli-item {
            display: -webkit-box;
            display: flex;
            color: #999999;
            font-size: 1.4rem;
            line-height: 2rem;
            margin-top: 0.5rem;

            &:first-child {
                margin-top: 0;
            }

            .name {
                font-family: PingFangSC-Semibold;
                min-width: 4.2rem;
            }
            .val {
                -webkit-box-flex: 1;
                flex: 1;
                padding-left: 1rem;
            }
        }
        .text {
            font-size: 1.4rem;
            color: #333;
            padding: 1.8rem 0 1.2rem;
        }

        .phone-wrap {
            position: relative;
            padding: .8rem 0;
            margin-bottom: 1rem;

            &:before {
                .border-1px(#ccc);
                border-radius: .2rem;
            }

            .input-phone {
                position: relative;
                z-index: 1;
                display: block;
                width: 100%;
                box-sizing: border-box;
                height: 2.4rem;
                line-height: 2.4rem;
                padding: 0 1rem;
                color: #333333;
                font-size: 1.5rem;
            }
        }

        .veri-code-box {
            &::after {
                content: '';
                display: block;
                height: 0;
                clear: both;
            }

            .code input, .get-code-btn {
                box-sizing: border-box;
            }
            .code {
                position: relative;
                float: left;
                padding: .8rem 0;
                width: 68%;

                input {
                    display: block;
                    position: relative;
                    z-index: 1;
                    width: 100%;
                    font-size: 1.5rem;
                    text-align: left;
                    padding: 0 1rem;
                    height: 2.4rem;
                    line-height: 2.4rem;
                    color: #333;
                }

                &:before {
                     .border-1px(#ccc);
                     border-radius: .2rem;
                }
            }
            .get-code-btn {
                position: relative;
                float: right;
                font-size: 1.4rem;
                height: 4rem;
                line-height: 4rem;
                text-align: center;
                width: 30%;
                color: #333;
                border-radius: .2rem;

                &:before {
                    .border-1px(#bbb);
                    border-radius: .2rem;
                }

                &.gray {
                    background: #ccc;
                    color: #fff;
                    
                    &:before {
                        border: none;
                    }
                }
            }
        }

        .book-btn {
            position: relative;
            z-index: 2;
            height: 4.4rem;
            line-height: 4.4rem;
            color: #fff;
            font-size: 1.8rem;
            border-radius: .5rem;
            margin: 2rem auto 0;
            text-align: center;
            // letter-spacing: .5rem;
            background: #f63;

            &.is-mt {
                background: #FF9900;
                border-radius: .2rem;
            }
        }
    }

    .slide-enter, .slide-leave-to {
        transform: translateY(100%);
    }
    .slide-enter-active, .slide-leave-active {
        transition: all .3s;
    }
    .slide-enter-to {
        transform: translateY(0);
    }
</style>


// WEBPACK FOOTER //
// src/components/BookView.vue